import React from 'react';
import { Card, Checkbox, Col, Form, Input, Row } from 'antd';
import { inputSize } from '../../../Shared/UI/jsx';

const { Item } = Form;

const Languages = ({ form }) => {

    return(
        <Card size="small" title="Languages" className='formCard'>
            <Form
                form={form}
                size="small"
                layout="vertical"
            >
                <Row>
                    <Col span={8}>
                        <Item name="burmese" valuePropName="checked">
                            <Checkbox disabled>
                                Burmese
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="falamChin" valuePropName="checked">
                            <Checkbox disabled>
                                Falam
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="hakhaChin" valuePropName="checked">
                            <Checkbox disabled>
                                Hakha
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="matuChin" valuePropName="checked">
                            <Checkbox disabled>
                                Matu
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="tedimChin" valuePropName="checked">
                            <Checkbox disabled>
                                Tedim
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="zopheiChin" valuePropName="checked">
                            <Checkbox disabled>
                                Zophei
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="filipino" valuePropName="checked">
                            <Checkbox disabled>
                                Tagalog
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="french" valuePropName="checked">
                            <Checkbox disabled>
                                French
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="frenchCajun" valuePropName="checked">
                            <Checkbox disabled>
                                French Cajun
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="frenchCanadian" valuePropName="checked">
                            <Checkbox disabled>
                                French Canadian
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="haitainCreole" valuePropName="checked">
                            <Checkbox disabled>
                                Haitian Creole
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="german" valuePropName="checked">
                            <Checkbox disabled>
                                German
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="punjabi" valuePropName="checked">
                            <Checkbox disabled>
                                Punjabi
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="spanish" valuePropName="checked">
                            <Checkbox disabled>
                                Spanish
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="vietnamese" valuePropName="checked">
                            <Checkbox disabled>
                                Vietnamese
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="somali" valuePropName="checked">
                            <Checkbox disabled>
                                Somali
                            </Checkbox>
                        </Item>
                    </Col>
                    {/* Changed to Hindi */}
                    <Col span={8}>
                        <Item name="frenchCajun" valuePropName="checked">
                            <Checkbox disabled>
                                Hindi
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="swahili" valuePropName="checked">
                            <Checkbox disabled>
                                Swahili
                            </Checkbox>
                        </Item>
                    </Col>
                    <Col span={8}>
                        <Item name="otherLanguage" label="Other Language">
                            <Input style={inputSize} />
                        </Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}

export default Languages;